@if(isFormSubmissionCallRunning) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
    <div class="register--container">
        <div class="register-content--form-container mat-elevation-z3">
            @if(isFormSubmitted){
                @if(!isFormSubmissionCallRunning) {
                    <div>
                        <h1>{{isFormSubmissionError ? 'Error!' : 'Success!'}}</h1>
                        <span id="register-response--message">{{messageToDisplayAfterSubmission}}</span>
                    </div>
                    <div>
                        <a href="/"><button mat-raised-button class="blue-button">Back</button></a>
                        <a href="/register"><button mat-stroked-button class="white-button">Register</button></a>
                        <a href="/login"><button mat-stroked-button class="white-button">Login</button></a>
                    </div>
                }
            }@else {
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <div class="form-content--field-container">
                        <h1 class="centered-text">Request a Login</h1>
                        <mat-form-field appearance="outline">
                            <input matInput placeholder="First name" formControlName="fname">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <input matInput placeholder="Last name" formControlName="lname">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <input matInput placeholder="Email" formControlName="email">
                            @if(registerForm.get('email')?.hasError('required')) {
                                <mat-error>Email is required</mat-error>
                            }@else if (registerForm.get('email')?.hasError('email')) {
                                <mat-error>Email is not valid</mat-error>
                            }
                        </mat-form-field>
                        <div class="form-actions--button-contaienr">
                            <button mat-raised-button class="blue-button" type="submit" [disabled]="registerForm.invalid">Register</button>
                            <a href="/"><button mat-stroked-button type="button" class="white-button">Cancel</button></a>
                        </div>
                    </div>
                </form>
            }
        </div>
        <div class="register-content--hint-wrapper">
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> Hint #1 </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>If you have not downloaded the username list, <a href="/files/EMAIL_LIST.txt" download>do so here</a>. If you did, procede to the next hint.</p>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> Hint #2 </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>BurpSuite is a handy tool to automating requests</p>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> Hint #3 </mat-panel-title>
                    </mat-expansion-panel-header>
                    <a href="https://portswigger.net/web-security/authentication/password-based#username-enumeration">https://portswigger.net/web-security/authentication/password-based#username-enumeration</a>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> Hint #4 - Solution</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ol>
                        <li>Download the username list to your downloads directory</li>
                        <li>Launch BurpSuite</li>
                        <li>Depending on your BurpSuite configuration, either launch the BurpSuite browser or use a Browser Extension</li>
                        <li>Browswer -> Fill out the user profile registration form manually with any info you want</li>
                        <li>BurpSuite -> Proxy Tab -> Turn on intercept to start capturing traffic</li>
                        <li>Browser -> Click register button to submit the form</li>
                        <li>BurpSuite -> You should see /api/users OPTIONS requet -> Forward</li>
                        <li>You should see /api/users POST requet -> Right Click -> Send to Intruder</li>
                        <li>Toggle off the proxy intercept off -> Go to Intruder tab</li>
                        <li>Highlight the email address you used inside the double quotes -> Click the 'Add S' button next to POSITIONS to make it a position variable</li>
                        <li>In the 'Payload Configuration' section click load -> Selet the EMAIL_LIST.txt file</li>
                        <li>In the 'Payload Encoding' section, toggle off URL Encoding</li>
                        <li>Click the Start Attack button -> Wait for the attack to finish -> Sort be response codes</li>
                        <li>Select the one with the 418 response code -> Review the request and see the email was <code>atorres&#64;gmail.com</code></li>
                    </ol>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
}
